import React from 'react';
import EcoTabSectionLR from 'eco-design/sections/eco-tab-section-l-r';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const IndustryLeadingD: React.FC = () => {
    const { t } = useLang('Delta3MaxSeriesStation.IndustryLeadingD');

    const descDataItems = [
        {
            title: t.rich('item1_title', {
                text1: (text: string) => <span>{text}</span>,
            }),
            desc: t('item1_desc'),
            tips: t('item1_tips'),
        },
        {
            title: t.rich('item2_title', {
                text1: (text: string) => <span>{text}</span>,
            }),
            desc: t('item2_desc'),
            tips: t('item2_tips'),
        },
        {
            title: t.rich('item3_title', {
                text1: (text: string) => <span>{text}</span>,
            }),
            desc: t('item3_desc'),
            tips: t('item3_tips'),
        },
        {
            title: t.rich('item4_title', {
                text1: (text: string) => <span>{text}</span>,
            }),
            desc: t('item4_desc'),
            tips: t('item4_tips'),
        },
    ];

    const getContentDesc = (index: number) => {
        const itemData = descDataItems[index];
        return (
            <div className={`right-item item-${index}`}>
                <div className={`item-title item-${index}-title`}>{itemData.title}</div>
                <div className="item-desc">{itemData.desc}</div>
                <div className="item-tips">{itemData.tips}</div>
            </div>
        );
    };

    return (
        <section className={`${styles.IndustryLeadingD} GtmModuleData-section`} id="IndustryLeadingD" data-section-id={'IndustryLeadingD'}>
            <div className="industry-bg-wrap">
                <div className="title-box">
                    <h4 className="title">{t('title')}</h4>
                    <p className="desc">{t('desc')}</p>
                </div>
                <EcoTabSectionLR
                    className="section-card-faq"
                    items={[
                        {
                            title: '',
                            desc: getContentDesc(0),
                            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1760967103185-3iyj5m-compressed-Mask%20group.jpg',
                            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1760967155325-304305-compressed-Mask%20group.jpg',
                            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1760967155325-304305-compressed-Mask%20group.jpg',
                            tabLabel: t('tab_1'),
                            tabValue: 'a',
                        },
                        {
                            title: '',
                            desc: getContentDesc(1),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1756974111635/industry-d-2-pc.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1757939068817/Group%201612707780.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757939068817/Group%201612707780.jpg',
                            tabLabel: t('tab_2'),
                            tabValue: 'b',
                        },
                        {
                            title: '',
                            desc: getContentDesc(2),
                            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1760963311036-yb8txc-compressed-Group%201612707014.jpg',
                            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1760963338050-fs1q34-compressed-Group%201612707781.jpg',
                            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1760963338050-fs1q34-compressed-Group%201612707781.jpg',
                            tabLabel: t('tab_3'),
                            tabValue: 'c',
                        },
                        {
                            title: '',
                            desc: getContentDesc(3),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1756974112127/industry-d-4-pc.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1757939068467/Group%201612707782.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757939068467/Group%201612707782.jpg',
                            tabLabel: t('tab_4'),
                            tabValue: 'd',
                        },
                    ]}
                />
            </div>
        </section>
    );
};

export default IndustryLeadingD;
